import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionsCreators } from "../../../actions";
import strings from "../../../helpers/Localization";
import dayjs from "dayjs";
import dayjsPluginUTC from "dayjs/plugin/utc";
dayjs.extend(dayjsPluginUTC);

import { toast } from "react-toastify";

//CUSTOM COMPONENT
import Area from "../../../aGlobalDesign/Area/Area";
import PaginationList from "../../../aGlobalDesign/Pagination/PaginationList";
import IconComponent from "../../../aGlobalDesign/Icons/IconComponent";
import Badge from "../../../aGlobalDesign/Badges/Badge";

class CallApp extends React.Component {

    constructor() {
        super();
        this.state = {
            searchField: "",
            forcePaginationUpdate: 0,
            appcallsList: null
        };
    }
    componentDidMount() {
        this.props.changeAppBarTitle(strings.CallApp);
        this.props.ChangeCurrentMenuName("CallApp");

        if (!this.props.monitoring.secondaryFreeCallLinks) {
            this.props.GetSecondaryFreeCallLinkList(() => {
                this.forcePaginationUpdate();
            });
        }
    }
    forcePaginationUpdate() {
        const temp = this.state.forcePaginationUpdate + 1;
        this.setState({
            selectedCallCenter: null,
            openModal: 0,
            forcePaginationUpdate: temp
        });
    }
    componentDidUpdate(prevProps) {
        if (this.props.reload && this.props.reload !== prevProps.reload) {
            this.forcePaginationUpdate();
        }
    }
    getStatus(stat) {
        switch (stat) {
            case 60 : return strings.CallInProgress;
            case 45 : return strings.WaitingList;
            case 10 : return strings.OffLine;
            case 20 : return strings.OffLine;
            case 30 : return strings.BreakMode;
            case 40 : return strings.Available;
            case 50 : return strings.IncomingCall;
            case 70 : return strings.SleepMode;
            default : return strings.NoStatus;
        }
    }
    getCallLink(ca) {
        if (!ca || !ca.callLinkGuid) {return null;}
        if (this.props.monitoring.secondaryFreeCallLinks) {
            const fcl = this.props.monitoring.secondaryFreeCallLinks.results.find(fc => fc.guid === ca.callLinkGuid);
            if (!fcl) {return null;}
            return fcl.link;
        }
    }
    getDevice(dt) {
        switch (dt) {
            case "mobile" : return strings.Mobile;
            case "pc" : return strings.Computer;
            case "" : return strings.Capsule;
            case null : return strings.Capsule;
            case undefined : return strings.Capsule;
            default : return dt;
        }
    }
    //#endregion

    render() {
        const accessrights = this.props.currentuser && this.props.currentuser.accessrights ? this.props.currentuser.accessrights : null;
        const sortedList = this.props.monitoring.callapps ? this.props.monitoring.callapps.map((ca, index) => {
            if (ca.callLinkGuid && this.state.zoneList && this.state.zoneList.find(z => z.id === ca.zone.id)) {
                return { ca: ca, id: "#" + (index + 1) };
            }
        }) : [];
        return <>
            <PaginationList
                forcePaginationUpdate={this.state.forcePaginationUpdate}

                onGetElements={
                    (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess, secondary) => {
                        const accessRight = this.props.currentuser.accessrights ? this.props.currentuser.accessrights.hasPermission(410, "consult") : 0;
                        this.props.GetRestrictedZones((data) => {
                            let zoneList = [];
                            if (accessRight < 10 || !data.results || data.results.length <= 0) {
                                zoneList = [];
                            }
                            else {
                                zoneList = data.results;
                            }
                            const result = {
                                pageNumber: pageNumber,
                                pageSize: 1000,
                                sortExpression: sortExpression,
                                filterExpression: filterExpression,
                                tagSearchRequest: tagSearchRequest,
                                PaginationType: this.props.administration.paginationtypewebcall ? this.props.administration.paginationtypewebcall : PaginationType,
                                results: this.props.monitoring.callapps ? this.props.monitoring.callapps.map(ca => {
                                    if (ca.callLinkGuid && zoneList.find(z => z.id === ca.zone.id)) {
                                        return ca;
                                    }
                                }) : []
                            };
                            onSuccess(this.props.monitoring.callapps ? result : null);
                            this.setState({
                                appcallsList: result,
                                zoneList: zoneList
                            });
                        }, accessRight
                        );
                    }
                }
                onSavePagination={(paginationType) => {
                    this.props.EditPaginationListType("webcall", paginationType);
                    this.setState({ appcallsList: { ...this.state.appcallsList, PaginationType: paginationType } });
                }}
                myElements={{ ...this.state.appcallsList,
                    PaginationType: this.props.administration && this.props.administration.paginationtypewebcall ? this.props.administration.paginationtypewebcall : this.state.appcallsList ? this.state.appcallsList.PaginationType : null,
                    results: sortedList
                }}

                sortOptions={[
                    { sortName: "name", sortData: "asc" }
                ]}

                tableElement={(rawelement, onReloadList) => {
                    const element = rawelement && rawelement.ca ? rawelement : rawelement ? { ca: rawelement } : null;
                    const callLink = element ? this.getCallLink(element.ca) : null;
                    return [
                        {
                            colTitle: "ID",
                            fixedWidth: "50px",
                            lockWidth: true,
                            cellRenderer: ({ tableManager, stringvalue, field, data, column, colIndex, rowIndex }) => {
                                return "#" + rowIndex;
                            }
                        },
                        {
                            colTitle: strings.SortStatus,
                            fixedWidth: "130px",
                            colContent: element ? this.getStatus(element.ca.status) : null
                        },
                        {
                            colTitle: strings.Position,
                            fixedWidth: "100px",
                            lockWidth: true,
                            justify: "center",
                            colContent: element ? element.ca.position : null
                        },
                        {
                            colTitle: strings.Zone,
                            fixedWidth: "160px",
                            colContent: element && element.ca.zone ? element.ca.zone.name : null
                        },
                        {
                            colTitle: strings.SortCallCenter,
                            fixedWidth: "160px",
                            colContent: element && element.ca.callCenter ? element.ca.callCenter.name : null
                        },
                        {
                            colTitle: "Lien d'appel",
                            fixedWidth: "300px",
                            cellRenderer: ({ tableManager, stringvalue, field, data, column, colIndex, rowIndex }) => {
                                const value = data[column.field];
                                if (value) {
                                    return <div style={{ display: "flex", flexDirection: "row", gap: "0px", alignItems: "center", justifyItems: "center" }}>
                                        <span style={{ overflow: "hidden", flexGrow: 1, width: "250px", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                            {value.callLink.replace("https://", "").replace(".azurewebsites.net", "")}
                                        </span>
                                        <button type='button' className="button-round-secondary-icon-without-text" style={{ border: "transparent" }}
                                            onClick={() => {
                                                navigator.clipboard.writeText(value.callLink);
                                                toast.success("Copied to clipboard");
                                            }}>
                                            <IconComponent nameIcon="clipboardcopy" color="carbone"/>
                                        </button>
                                    </div>;
                                }
                                else {return "";}
                            },
                            colContent: element ? {
                                callLink: callLink } : null
                        },
                        {
                            colTitle: "Appareil",
                            fixedWidth: "100px",
                            lockWidth: true,
                            colContent: element ? this.getDevice(element.ca.deviceType) : strings.Capsule
                        }
                    ];
                }}
            />
        </>;
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActionsCreators, dispatch);
};

export default connect(
    (state) => state,
    mapDispatchToProps
)(CallApp);
